document.querySelectorAll('.yrp-site-nav').forEach(function(menu){
  if(menu.dataset.bound)return;
  menu.dataset.bound='true';
  var trigger=menu.querySelector(':scope > summary');
  var panel=menu.querySelector('.yrp-site-nav__panel');
  var position=function(){
    if(!menu.open)return;
    var header=menu.closest('.yrp-banner-header,.header');
    var bottom=header?Math.max(0,header.getBoundingClientRect().bottom):0;
    menu.style.setProperty('--yrp-nav-top',Math.round(bottom)+'px');
  };
  window.addEventListener('resize',position);
  document.addEventListener('click',function(event){if(menu.open&&!menu.contains(event.target))close();});
  var close=function(){menu.open=false;document.body.classList.remove('yrp-nav-open');trigger.focus();};
  menu.querySelectorAll('[data-yrp-nav-close]').forEach(function(button){button.addEventListener('click',close);});
  menu.addEventListener('toggle',function(){
    document.body.classList.toggle('yrp-nav-open',menu.open);
    trigger.setAttribute('aria-expanded',String(menu.open));
    if(menu.open){position();panel.querySelector('summary,a[href],button').focus();}
  });
  menu.addEventListener('keydown',function(event){
    if(!menu.open)return;
    if(event.key==='Escape'){event.preventDefault();close();}
    if(event.key==='Tab'){
      var items=[trigger].concat(Array.from(panel.querySelectorAll('a[href],button,summary'))).filter(function(item){return item.getClientRects().length>0;});
      var first=items[0],last=items[items.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    }
  });
});